export default __webpack_public_path__ + "static/media/databankv5_combined.e0f9ca60.csv";